import { useEffect, useState } from "react";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

const fmt = (d) => new Date(d.endsWith?.("Z") ? d : `${d}Z`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

const message = (s) => {
  if (s.expired) return `This link has expired. You can ask ${s.name} to renew it, and the same link will work again.`;
  return `Your link to ${s.name} expires in ${s.days_left} day${s.days_left === 1 ? "" : "s"}. Ask ${s.name} to renew it so you don't lose access.`;
};

export const SupporterLinkStatus = ({ token }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/supporters/view/${token}/link-status`).then((r) => setS(r.data)).catch((e) => logError("Link status failed:", e));
  }, [token]);

  const ask = async () => {
    setBusy(true); setErr("");
    try { await api.post(`/supporters/view/${token}/renewal-request`); setS((x) => ({ ...x, requested: true, can_request: false })); }
    catch (e) { setErr(errMsg(e, "Couldn't send your request")); }
    finally { setBusy(false); }
  };

  if (!s || (!s.expired && !s.can_request && !s.requested)) return null;
  return (
    <div className="mm-card p-6" data-testid="supporter-link-status">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-2xl bg-mm-primary/10 text-mm-primary flex items-center justify-center shrink-0"><KeyRound size={20} /></div>
        <div className="flex-1">
          <div className="font-semibold" data-testid="supporter-link-status-title">{s.expired ? "Link expired" : "Link expiring soon"}</div>
          <p className="text-sm text-mm-muted mt-1" data-testid="supporter-link-status-text">{message(s)}</p>
          {s.requested ? (
            <p className="text-sm mt-3 text-mm-primary font-medium" data-testid="supporter-renewal-sent">
              Request sent to {s.name}. {s.next_request_at ? `You can ask again after ${fmt(s.next_request_at)}.` : "We'll email you when it's renewed."}
            </p>
          ) : (
            <button className="mm-btn mt-4 !py-2 !px-5 text-sm" onClick={ask} disabled={busy} data-testid="supporter-renewal-request-btn">
              {busy ? "Sending…" : `Ask ${s.name} to renew`}
            </button>
          )}
          {err && <p className="text-sm text-red-600 mt-2" data-testid="supporter-renewal-error">{err}</p>}
        </div>
      </div>
    </div>
  );
};
